import { Button, Intent } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import autobind from "autobind-decorator";

import { BoxView } from "common/views/box/Box.view";
import { BoxVariant } from "common/views/box/Box.view";
import EntityForm from "core/components/EntityForm";
import Label from "core/components/label/Label";
import TokenSession from "core/util/session/TokenSession";
import { iDef } from "core/util/TypeUtils";
import * as React from "react";
import { FlexJustify } from "../../../../common/fragments/Flex";
import Topic from "../../entity/Topic";
import { ForumToaster } from "../../forumActions";
import TopicComponentConfig from "./TopicComponentConfig";
import draftToHtml from 'draftjs-to-html';
import convertToHtml from "common/fragments/ConvertToHtml";

enum Mode {
	CREATE,
	EDIT,
	REPLY
}


interface ITopicFormProps {
	topicId?: number; // if topic id is undefined we set the
	parentId?: number;
	categoryId?: number;
	onAfterSave?: (topic: Topic) => void;
	border?: boolean;
	onClose?: () => void;
	topic?: Partial<Topic>;
	tagsEnabled?: boolean;
	config?: TopicComponentConfig;
}

export default class TopicFormComponent extends React.Component<ITopicFormProps> {
	private mode: Mode;
	private attributeToConvert = 'description';

	constructor(props) {
		super(props);

		if (iDef(props.topicId)) {
			this.mode = Mode.EDIT;
		} else if (iDef(props.parentId)) {
			this.mode = Mode.REPLY;
		} else {
			this.mode = Mode.CREATE;
		}

	}

	@autobind
	public onBeforeSave(topic: Topic): Topic {
		const { parentId, categoryId } = this.props;

		// if we are creating a new reply. set the parent id to the id that was passed into our component
		if (Mode.REPLY === this.mode && iDef(parentId)) {
			topic.parent = parentId;
			topic.name = "re:" + parentId;
		}

		if (iDef(categoryId)) {
			topic.category = categoryId;
		}
		const description = convertToHtml(topic.description);

		if (topic.id !== undefined) {
			topic = { id: topic.id, name: topic.name,  description: description, parent: topic.parent || null, category: topic.category, attachments: topic.attachments || [], tags:topic.tags || [], displayName: TokenSession.getUser() && TokenSession.getUser().getName() } as any;
		} else {
			topic = { name: topic.name,  description: description, parent: topic.parent || null, category: topic.category, attachments: topic.attachments || [], tags:topic.tags || [], displayName: TokenSession.getUser() && TokenSession.getUser().getName() } as any;
		}

		return topic;
	}

	@autobind
	public onAfterSave(result: Topic) {
		ForumToaster.show({
			intent: Intent.SUCCESS,
			message: "Post created"
		});

		this.props.onAfterSave(result);
	}

	@autobind
	private onSelect(picked: any) {
		console.log(picked);
	}

	public render() {
		const { categoryId, parentId, onClose, topic } = this.props;
		const excluded = [];

		// if we are replying or editing a reply to a topic dont display
		// the cageotry select and the title field	

		if (iDef(categoryId)) {
			excluded.push("category");
		}

		if((topic && topic.isReply !== null) || iDef(parentId)) {
			excluded.push("name");
		}

		if(!this.props.tagsEnabled) {
			excluded.push("tags");
		}

		let copyTopic = topic;

		if (topic && topic.categoryEntity) {
			copyTopic = { ...topic, category: topic.categoryEntity.id };
		}

		if (topic && topic.tagEntities) {
			let tagIds = topic.tagEntities.map(t => t.id) as number[];
			if(tagIds && tagIds.length)	{
				copyTopic = { ...copyTopic, tags: tagIds } ;
			}
		}

		const form = <EntityForm instance={copyTopic} refetch={false} clazz={Topic} afterSave={this.onAfterSave} beforeSave={this.onBeforeSave} excludedFields={excluded} 
						config={{...this.props.config}} attributeToConvert={this.attributeToConvert}/>;

		if (this.props.border) {
			let title;

			switch (this.mode) {
				case Mode.CREATE:
					title = <Label k="topic.new" v="Create a Post" />;
					break;
				case Mode.EDIT:
					title = <Label k="topic.edit" v="Edit Post" />;
					break;
				case Mode.REPLY:
					title = <Label k="topic.reply" v="Reply To Post" />;
					break;
			}

			if (typeof onClose === "function") {
				title = (
					<FlexJustify>
						{title}

						<Button
							icon={IconNames.CROSS}
							minimal={true}
							onClick={onClose}
						/>
					</FlexJustify>
				);
			}

			return (
				<BoxView viewKey="topic.new" variant={BoxVariant.PANEL} title={title}>
					{form}
				</BoxView>
			);
		}

		return form;
	}
}




// WEBPACK FOOTER //
// ./src/panels/forum/component/topic/TopicFormComponent.tsx